export default {"src":"/_next/static/media/0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e.f75ac279.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};